/** The pages anyone can read, signed in or not (screens/Public.tsx): no header, no under-development band. */
export const PUBLIC_PAGES = ['/about', '/privacy', '/terms', '/blog'] as const;

export const isPublicPage = (pathname: string) => PUBLIC_PAGES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

/**
 * Pages in the portal's frame: its header, and once signed in its foot (components/PortalFoot.tsx). Sign-in and the
 * links that land on it (`/auth/…`) carry their own larger lockup, OAuth's Allow page sits as they do, and the public
 * pages have their own way round.
 */
export const framed = (pathname: string) => !(pathname === '/login' || pathname.startsWith('/auth/') || pathname.startsWith('/oauth/') || isPublicPage(pathname));

/**
 * The way round the public pages, the page you are on left out: from them, Sign in, or Back to the portal for someone
 * signed in (design study 30); at the portal's foot the pages alone, What's new being its latest article there.
 */
export function wayRound(pathname: string, reader: 'signed out' | 'signed in' | 'in the portal'): [string, string][] {
  const start: [string, string][] = reader === 'signed out' ? [['/login', 'Sign in']] : reader === 'signed in' ? [['/', 'Back to the portal']] : [];
  const pages: [string, string][] = [
    ['/about', 'About the portal'],
    ['/privacy', 'Privacy'],
    ['/terms', 'Terms'],
  ];
  const blog: [string, string][] = reader === 'in the portal' ? [] : [['/blog', 'What’s new']];
  return [...start, ...pages, ...blog].filter(([to]) => to !== pathname);
}
